import type { InterfacePageEntity } from '@unifyapps/defs/types/page';
import type { InterfaceStoreState, InterfaceStoreStateGetterAndSetter } from '../runner/types';

export type UpdateInterfacePageActionProps = {
  interfacePage: InterfacePageEntity;
};

const getUpdateInterfacePageAction =
  <T extends InterfaceStoreState>(storeArgs: InterfaceStoreStateGetterAndSetter<T>) =>
  (args: UpdateInterfacePageActionProps) => {
    const { set } = storeArgs;
    const { interfacePage } = args;
    set((state) => ({
      ...state,
      activeInterfacePage:
        state.activeInterfacePageId === interfacePage.id
          ? interfacePage
          : state.activeInterfacePage,
      interfacePages: { ...state.interfacePages, [interfacePage.id]: interfacePage },
    }));
  };

export default getUpdateInterfacePageAction;
